// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SisternodeOutlinedSvg from "@fishx/icons-svg/es/asn/SisternodeOutlined";
import FishxIcon from '../components/FishxIcon';

var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SisternodeOutlinedSvg
  }));
};

SisternodeOutlined.displayName = 'SisternodeOutlined';
export default React.forwardRef(SisternodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SisternodeOutlined.js
// module id = 4124
// module chunks = 0